export default "__VITE_ASSET__e2fxHg7E__"